export default __webpack_public_path__ + "static/media/icons8-linkedin.c304a414.svg";